<template>
  <div :class="{'nav-open': true}">

    <router-view></router-view>
  </div>
</template>

<script>
  export default {
   async created() {
     
    }

  }
</script>
<style >
 
</style>
